var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40537",
    "data-name": "Group 40537",
    transform: "translate(9609 18582)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15359",
    "data-name": "Rectangle 15359",
    width: 16,
    height: 16,
    transform: "translate(-9609 -18582)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "minus",
    d: "M4,11.875A.875.875,0,0,1,4.875,11h12.25a.875.875,0,0,1,0,1.75H4.875A.875.875,0,0,1,4,11.875Z",
    transform: "translate(-9612 -18581)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.172e3b28ba60c9420a7026ec7ef5281f.svg";
export { ForwardRef as ReactComponent };